import { render, staticRenderFns } from "./TaxLosses.vue?vue&type=template&id=5718b624"
import script from "./TaxLosses.vue?vue&type=script&lang=js"
export * from "./TaxLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5718b624')) {
      api.createRecord('5718b624', component.options)
    } else {
      api.reload('5718b624', component.options)
    }
    module.hot.accept("./TaxLosses.vue?vue&type=template&id=5718b624", function () {
      api.rerender('5718b624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/tax_return/TaxLosses.vue"
export default component.exports